import { deviceMapTypes } from "../actions/deviceMap";
import { authTypes } from "../actions/auth";
import usDateFormatLast7Days from "../../global/utility/usDateFormatLast7Days";
const { startDateTime, endDateTime } = usDateFormatLast7Days(new Date());

const initialState = {
  currentId: "",
  isLoading: false,
  startDateTime: startDateTime,
  endDateTime: endDateTime,
  isPlaying: false,
  currentIndex: 0,
  currentButtonActive: "play",
  data: [],
  error: "",
};

const deviceExplorerReducer = (state = initialState, action) => {
  switch (action.type) {
    case deviceMapTypes.UPDATE_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    case deviceMapTypes.HANDLE_DEVICE_MAP_PLAY_PAUSE_REQUEST:
      return {
        ...state,
        isPlaying: action.payload,
      };
    case deviceMapTypes.HANDLE_DEVICE_MAP_PLAY_PAUSE_SUCCESS:
      return {
        ...state,
        isPlaying: action.payload.isPlaying,
        currentIndex: action.payload.currentIndex
      };
    case deviceMapTypes.HANDLE_DEVICE_MAP_PLAY_PAUSE_FAILURE:
      return {
        ...state,
        isPlaying: false,
        currentIndex: 0
      };
    case deviceMapTypes.FETCH_DEVICE_MAP_REQUEST: {
      return action.payload?.initial ? {
        ...state,
        isLoading: true,
        isPlaying: false,
        currentIndex: 0,
        startDateTime: state.startDateTime,
        endDateTime: state.endDateTime,
        currentId: action.payload.id,
      } : {
        ...state,
        isLoading: true,
        isPlaying: false,
        currentIndex: 0,
        currentId: action.payload.id,
      };
    }
    case deviceMapTypes.FETCH_DEVICE_MAP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: null,
      };
    case deviceMapTypes.FETCH_DEVICE_MAP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case authTypes.LOGOUT:
    case authTypes.AUTO_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default deviceExplorerReducer;
